import { render, staticRenderFns } from "./AsPurchaserList.vue?vue&type=template&id=36303123&"
import script from "./AsPurchaserList.vue?vue&type=script&lang=js&"
export * from "./AsPurchaserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports